export const LeadStatusEnum = {
  IN_PROGRESS: 'IN_PROGRESS',
  HANDLED: 'HANDLED'
} as const;

export type LeadStatusEnum = typeof LeadStatusEnum[keyof typeof LeadStatusEnum];
